import { render, staticRenderFns } from "./UserPaymentMethodList.vue?vue&type=template&id=16c29ced&"
import script from "./UserPaymentMethodList.vue?vue&type=script&lang=js&"
export * from "./UserPaymentMethodList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports